export const SUPPORTED_PATIENT_DOCUMENT_TYPE_INITIALS = [
  "DNI",
  "LC",
  "LE",
  "CI",
  "CIPF",
  "PAS",
  "CIE",
  "DNIE",
  "PN",
] as const;

export const SUPPORTED_LEGAL_SEX_LETTERS = ["F", "M", "X"] as const;

export const PRIORITIZED_PATIENT_COUNTRY_NAME = "ARGENTINA";
